<template>
  <div class="c-guided-quiz-progress-bar">
    <div class="c-guided-quiz-progress-bar__fill j-guided-quiz-progress-bar__fill-width" />
  </div>
</template>

<script>
export default {
  name: "GuidedQuizProgressBar",
  props:{
    totalSteps: {
      type: Number,
      default: 2
    },
    currentStep:{
      type: Number,
      default: 0
    }
  },
  data(){
    return {

    }
  },
  watch: {
    currentStep(){
      this.displayProgress();
    }
  },
  mounted(){
    this.displayProgress();
  },
  methods: {
    displayProgress(){
      let prgs = this.$el.getElementsByClassName("j-guided-quiz-progress-bar__fill-width");
      if(prgs.length > 0){
        let prg = prgs[0];
        let perc = ((this.currentStep/this.totalSteps)*100);
        if(perc > 100){
          perc = 100;
        }
        prg.style.width = perc + "%";
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .c-guided-quiz-progress-bar{
    @include themify($themes){
      background-color: themed("background", "x-light");
    }
    height: 5px;
    width: 100%;
    overflow: hidden;
    margin-top: rem(10px);

    &__fill{
      @include themify($themes){
        background-color: themed("foreground");
      }
      position: relative;
      height: 5px;
      left: 0;
      top: 0;
      width: 0;
      transition: width 0.5s;
    }
  }
</style>